__turbopack_context__.v({
  "toast": "Toast-module__xbBehW__toast",
  "toastButtons": "Toast-module__xbBehW__toastButtons",
  "toastError": "Toast-module__xbBehW__toastError",
  "toastInfo": "Toast-module__xbBehW__toastInfo",
  "toastSuccess": "Toast-module__xbBehW__toastSuccess",
});
